import React from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export default function RatingCircularProgressbar({ count }) {
  const percentage = (count / 5) * 100; // Calculate percentage from count
  
  return (
    <CircularProgressbar
      value={percentage}       // Now correctly shows partial circle
      text={`${count}`}
      strokeWidth={12}
      styles={buildStyles({
        trailColor: "#e6e6e6", // grey background border (incomplete part)
        pathColor: "#08AF22",   // green for completed part
        textColor: "#08AF22",
        pathTransitionDuration: 0.8,
        strokeLinecap: "round",
      })}
    />
  );
}